export default {
  SUBTEXT_FOR_ORG_TYPE: {
    School:
      'Choose the default settings for new classes created at this school. If you have questions about your district defaults, contact your district administrator.',
    District:
      'Choose the default settings for new classes created at this district. Go to settings at the school-level to change the settings from the district default.',
  },

  HEADING_FOR_SETTING_TYPE: {
    classSearchabilityDefault: 'Class visibility',
    requestToJoinEnabledDefault: 'Require approval to join',
    participantMessagingStateDefault: 'Participant messaging',
  },

  BACKFILL_LABEL: 'Apply changes to existing classes',

  BACKFILL_TEXT_FOR_ORG_TYPE: {
    School:
      'Every class owner at this school will be notified with their updated default settings, which they can always change for their individual classes.',
    District:
      'Every class owner at this school will be notified with their updated default settings, which they can always change for their individual classes.',
  },

  CLASS_SEARCHABILITY_TO_LABEL: {
    searchable: 'On',
    unsearchable: 'Off',
  },

  CLASS_SEARCHABILITY_TO_HELPTEXT: {
    searchable: 'People can find the class by searching for the class owner’s name.',
    unsearchable: 'The class won’t appear in searches for the class owner’s name.',
  },

  REQUIRE_APPROVAL_TO_LABEL: {
    true: 'On',
    false: 'Off',
  },

  REQUIRE_APPROVAL_TO_HELPTEXT: {
    true:
      'People who try to join this class will need class owner approval to join. People added by the school or class owner are approved automatically.',
    false: 'People can join the class without waiting for approval from the class owner.',
  },

  PARTICIPANT_MESSAGING_TO_LABEL: {
    open: 'On',
    ownerOrSameRole: 'Role-based',
    ownersOnly: 'Off',
  },

  PARTICIPANT_MESSAGING_TO_HELPTEXT: {
    open: 'Participants can message others in the class.',
    ownerOrSameRole: 'Students can only messages students and parents can only message parents.',
    ownersOnly:
      'Participants can only message class owners. Existing conversations between participants won’t be affected by this setting.',
  },
};
